const QuestionResultSub = data => ({
  credits: {
    enabled: false
  },
  chart: {
    type: "bar",
    height: 600
  },
  title: false,
  xAxis: {
    labels: {
      enabled: false
    }
  },
  yAxis: {
    min: 0,
    max: 100,
    title: {
      enabled: false
    },
    tickInterval: 50
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        allowOverlap: true,
        color: "#000000",
        style: {
          fontSize: "14px",
          textOutline: "0.7px #ffffff"
        },
        format: "{y}%"
      }
    }
  },
  tooltip: {
    headerFormat: "",
    valueSuffix: "%",
    backgroundColor: "#ffffff",
    outside: true
  },
  legend: {
    width: 200,
    itemWidth: 100
  },
  series: data
});

export default QuestionResultSub;



// WEBPACK FOOTER //
// ./src/models/QuestionResultSub.js